module.exports = __webpack_public_path__ + "img/program-opening.17c7d4d5.jpg";